module.exports = "<div class=\"hidden-print hidden-xs hidden-sm\">\n    <nav class=\"bs-docs-sidebar\" :class=\"{affix:affixed}\" :style=\"{marginTop:top}\">\n      <slot></slot>\n    </nav>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=template&index=0!./src/Affix.vue
// module id = 125
// module chunks = 0